<template>
  <h2>
    {{ visibleSpotlight[0].is_affiliate ? "Affiliate" : "Spotlight" }} Link
  </h2>
  <div class="centered-objects">
    <div id="container">
      <transition-group
        name="spotlight-fade"
        tag="div"
        class="dynamic-container"
      >
        <template v-for="spotlight in visibleSpotlight" >
          <a
            class="spotlight"
            :href="spotlight.url"
            target="_blank"
            @click="trackEvent('Spotlight', { Spotlight: spotlight.title })"
            v-if="isValidUrl(spotlight.url)"
            :key="spotlight.id"
          >
            <img
              :src="spotlight.image_url"
              :alt="spotlight.title"
              :title="spotlight.description"
            />
          </a>
          <div v-else class="spotlight"
          :key="spotlight.id">
            <img
              :src="spotlight.image_url"
              :alt="spotlight.title"
              :title="spotlight.description"
              @click="setModal(spotlight.url, spotlight.title)"
            />
          </div>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slideInterval: {
      type: Number,
      default: 3000,
    },
    spotlights: {
      type: Array,
      required: true,
    },
  },
  inject: ["trackEvent"],
  emits: ["set-modal"],
  data() {
    return {
      elapsed: 0,
      timerId: null,
      currentPage: 0,
      randomizedSpotlights: [],
    };
  },
  computed: {
    pageCount() {
      return this.spotlights.length;
    },
    visibleSpotlight() {
      if (this.pageCount === 0) {
        return [];
      }
      return [this.randomizedSpotlights[this.currentPage]];
    },
  },
  methods: {
    shuffleSpotlights(spotlightArray) {
      const copied = [...spotlightArray];
      for (let i = copied.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copied[i], copied[j]] = [copied[j], copied[i]];
      }
      return copied;
    },
    setModal(modalText, spotlightTitle) {
      const parameters = this.parseModalParameters(modalText);
      this.trackEvent('Spotlight', { Spotlight: spotlightTitle })
      this.$emit("set-modal", ...parameters);
    },
    parseModalParameters(modalText) {
      const match = modalText.match(
        /Modal\s*\(\s*(['"])(.*?)\1\s*(?:,\s*(['"])(.*?)\3\s*)?\)/
      );

      if (!match) return [];
      const firstParam = match[2]; // first argument
      const secondParam = match[4]; // second argument, may be undefined

      // return only existing params
      return secondParam !== undefined
        ? [firstParam, secondParam]
        : [firstParam, null];
    },
    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    },
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.currentPage = (this.currentPage + 1) % this.pageCount;
    }, this.slideInterval);
  },
  watch: {
    spotlights: {
      immediate: true,
      handler(newSpotlights) {
        if (newSpotlights && newSpotlights.length) {
          this.randomizedSpotlights = this.shuffleSpotlights(newSpotlights);
        }
      },
    },
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>

<style scoped>
.spotlight {
  aspect-ratio: 5 / 1;
  margin: 0 auto;
  position: absolute;
  font-size: 2.5vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20vh;
  border: 1px solid rgba(0, 0, 0, 0.185);
  background-color: #dae4f4;
  flex: 0 1 auto;
  width: 100%;
  cursor: pointer;
}
.spotlight img {
  width: 100%;
}
.spotlight p {
  font-size: 4vh;
  font-weight: bold;
}
h2 {
  text-align: center;
}

.spotlight-fade-enter-active,
.spotlight-fade-leave-active {
  transition: transform 0.25s ease, opacity 0.5s ease;
}

.spotlight-fade-leave-to {
  opacity: 0;
  transform: translateY(1vh);
}

.spotlight-fade-enter-from {
  opacity: 0;
  transform: translateY(-1vh);
}

.dynamic-container {
  aspect-ratio: 5 / 1;
  display: flex;
  margin: 0 auto;
  position: relative;
  width: 100%;
}
#container {
  width: 38.75vh;
  display: flex;
  align-self: center;
  flex: 0 1 auto;
}
</style>
